module.exports = __webpack_public_path__ + "static/img/videoimg.0011f62.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/videoimg.jpg
// module id = MQ/k
// module chunks = 1